module.exports = __webpack_public_path__ + "img/pote-aberto.aac7c8af.png";